export enum CurrencyMetricType {
  Pipeline = 'pipeline',
  Bookings = 'bookings',
  Revenue = 'revenue'
}
